import { selectIsSubscriptionModalOpen } from "app/components/Modals/slice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "utils/redux/hooks";

const Subscribe = () => {
  const navigate = useNavigate();
  const isSubscriptionModalOpen = useAppSelector(selectIsSubscriptionModalOpen);

  useEffect(() => {
    if (!isSubscriptionModalOpen) {
      navigate("/");
    }
  }, [isSubscriptionModalOpen, navigate]);

  return <div />;
};

export default Subscribe;
